import { useQuery } from '@tanstack/react-query';

import { partnersApi, partnersApiKeys } from '@/api/routes/partners/partners.api';

/**
 * The signed-in user's partner account (`partner: null` before onboarding). `enabled: false` waits
 * for the session on pages that also render signed out (the invite).
 */
export const usePartnersReadMe = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: partnersApiKeys.me(),
    queryFn: () => partnersApi.me().then((res) => res.data),
    enabled,
  });
};
